module.exports = __webpack_public_path__ + "static/img/01.5da8b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/01.png
// module id = MtJ8
// module chunks = 64